import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rvn46uxywb: FaireBrandEntity = {
  token: "b_rvn46uxywb",
  type: "brand",
  name: "Holistic Homestead",
  avatarUrl:
    "https://cdn.faire.com/fastly/fdf8219aa093553b68718f95ab9a3190c263cf4e5fd2cc714ac7911647072e9a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f4351d0c37ded0ec4c1147c6958862afc48f373f88aad845065c072980ef3a05.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fdf8219aa093553b68718f95ab9a3190c263cf4e5fd2cc714ac7911647072e9a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4351d0c37ded0ec4c1147c6958862afc48f373f88aad845065c072980ef3a05.jpeg",
  location: "Brook Park, MN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 33,
  isTopShop: true,
  isInsider: true,
  description:
    "Holistic Homestead began in our home nearly a decade ago, creating products for our own family and children. In 2018 we launched our business and released our products locally where they quickly found a following. Our mission has always been to keep our prices affordable in an effort to help everyone have access to clean, natural, skincare & remedies. One way we do this is by growing what we use. The vast majority of the plants used in our remedies are organically grown or foraged on our herb & flower farm in central Minnesota & we use raw goat milk from our Nubian goats in our handcrafted herbal soap. In 2021 we opened a storefront on our homestead, transforming the farmhouse on the property into our boutique. As a homeschooling family with 4 children, we all have a hand in making this business run, truly a family owned and operated brand. We pride ourselves on offering the best ingredients in our handcrafted remedies & continuing to add value to our community. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:25.401Z",
    importedBy: "entity-db-cli",
  },
};
